"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setFolderMruConfigurationService_1 = require("../services/setFolderMruConfigurationService");
var store_1 = require("../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Action to remove a folderId fromn Mru list and save it to server
 * @param folderId - folderIs to remove from mru list
 */
exports.default = legacy_1.action('removeFolderIdFromMoveToMruList')(function removeFolderIdFromMoveToMruList(folderId) {
    var mruStore = store_1.getStore();
    var index = mruStore.mruFolders.indexOf(folderId);
    if (index < 0) {
        return;
    }
    mruStore.mruFolders.splice(index, 1);
    if (mruStore.isInitialized) {
        setFolderMruConfigurationService_1.default(mruStore.mruFolders);
    }
});
//# sourceMappingURL=removeFolderIdFromMoveToMruList.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-move-mru/lib/actions/removeFolderIdFromMoveToMruList.js
// module id = 4736
// module chunks = 51